import React, { FC } from 'react'

const PrivacyPolicy: FC<{ headerHeight: string }> = ({ headerHeight }) => {
  React.useEffect(() => {
    document.title = 'Privacy Policy'
  }, [])

  return (
    <iframe
      style={{ height: 'calc(100vh - ' + headerHeight + ')' }}
      src="/static/pdf/Arpeggi - Privacy Policy (1.23).pdf"
    />
  )
}

export default PrivacyPolicy
